export default __webpack_public_path__ + "static/media/our-partner-logo-14.8513dd81.jpeg";